import React from "react";
import Tittle from "../Components/Tittle";
import ImageSection from "../Components/ImageSection";
import SkillsSection from "../Components/SkillsSection";
import ServicesSection from "../Components/ServicesSection";
// import design from "../Assets/design.svg";
import intelligence from "../Assets/intelligence.svg";
// import gamedev from "../Assets/game-dev.svg";
import dataanal from "../Assets/data-analysis-resized.jpg";
import webdev from "../Assets/web-dev-resized.jpg";

function AboutPage() {
  return (
    <div className="AboutPage">
      <Tittle title={"About Me"} span={"About Me"} />
      <ImageSection />
      <Tittle title={"My Skills"} span={"My Skills"} />
      <div className="skillsContainer">
        <SkillsSection skill={"Python"} progress={"90%"} width={"90%"} />

        <SkillsSection skill={"Javascript"} progress={"85%"} width={"85%"} />
        <SkillsSection skill={"React.js"} progress={"85%"} width={"85%"} />
        <SkillsSection skill={"Express.js"} progress={"85%"} width={"85%"} />
        <SkillsSection skill={"REST APIs"} progress={"85%"} width={"85%"} />
        <SkillsSection skill={"HTML"} progress={"95%"} width={"95%"} />
        <SkillsSection skill={"CSS"} progress={"90%"} width={"90%"} />
        <SkillsSection skill={"Typescript"} progress={"60%"} width={"60%"} />
        <SkillsSection skill={"Node.js"} progress={"80%"} width={"80%"} />
        <SkillsSection skill={"Docker"} progress={"50%"} width={"50%"} />
        <SkillsSection skill={"Kubernetes/Helm"} progress={"50%"} width={"50%"} />
        <SkillsSection skill={"Shell/Bash Scripting"} progress={"60%"} width={"60%"} />
        <SkillsSection skill={"Java"} progress={"60%"} width={"60%"} />
        <SkillsSection skill={"GoLang(Go)"} progress={"30%"} width={"30%"} />
      </div>

      <Tittle title={"Databases"} span={"Databases"} />
      <div className="skillsContainer">
        <SkillsSection skill={"MongoDB"} progress={"90%"} width={"90%"} />
        <SkillsSection skill={"MySQL"} progress={"90%"} width={"90%"} />
        <SkillsSection skill={"PgSQL"} progress={"60%"} width={"60%"} />
        <SkillsSection skill={"SQLite3"} progress={"40%"} width={"40%"} />
        <SkillsSection skill={"Neo4j"} progress={"20%"} width={"20%"} />
      </div>

      <Tittle title={"Services"} span={"Services"} />
      <div className="servives-container">
        <ServicesSection
          image={webdev}
          title={"Web Development"}
          text={"Frontend, Backend, and containerization"}
        />
        <ServicesSection
          image={intelligence}
          title={"Artificial Intelligence"}
          text={"Computer Vision and Neural Networks"}
        />
        <ServicesSection
          image={dataanal}
          title={"Data Engineering"}
          text={"Data Analysis, Exploration, and ETL"}
        />
      </div>
    </div>
  );
}

export default AboutPage;
